// axios
import axios from 'axios'
const domain = "https://api.saveleads.com.br/weentrega/";
const token = localStorage.getItem("accessToken");
export default axios.create({
  baseURL: domain,
  headers: { Authorization: `Bearer ${token}` }
  // You can add your headers here
})
